import { useState, type ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary.js';

type Props = {
  children: ReactNode;
  fallback: (args: { onRetry: () => void; feature: string }) => ReactNode;
  feature: string;
  /** When true, skip boundary (customer recovery routes). */
  disabled?: boolean;
};

export function RemountBoundary({ children, fallback, feature, disabled }: Props): JSX.Element {
  const [retry, setRetry] = useState(0);
  const onRetry = (): void => setRetry((n) => n + 1);

  if (disabled === true) {
    return <>{children}</>;
  }

  return (
    <ErrorBoundary
      key={String(retry)}
      fallback={fallback({ onRetry, feature })}
      observability={{ feature }}
    >
      {children}
    </ErrorBoundary>
  );
}
